<template>
    <div
        :style="{ height: `${spinnerSize}px`, width: `${spinnerSize}px` }"
        class="loading-spinner"
    />
</template>

<script>
    export default {
        props: {
            spinnerSize: {
                type: Number,
                required: true,
            },
        },
    };
</script>

<style lang="scss">
    #cz2.cz2 {
        .loading-spinner {
            margin: 0 auto;
            border: 3px solid rgba(0, 0, 0, 0.5);
            border-bottom-color: black;
            border-radius: 50%;
            box-sizing: border-box;
            animation: rotation 1s linear infinite;
        }

        @keyframes rotation {
            0% {
                transform: rotate(0deg);
            }
            100% {
                transform: rotate(360deg);
            }
        }

        &.cz2__is-mariners {
            .loading-spinner {
                border: 3px solid rgba(255, 255, 255, 0.5);
                border-bottom-color: white;
            }
        }
    }
</style>
